import ActionTypes from "actions/ActionTypes";
import PagePath from "common/PagePath";

const initialState = {
  theme: "light",
  homePages: [
    {
      id: 0,
      title: "Quản lý mặt bằng",
      icon: "pin_drop",
      path: PagePath.SITE_2,
    },
    { id: 1, title: "Quản lý cửa hàng", icon: "store", path: PagePath.STORE },
    {
      id: 2,
      title: "Thông tin thị trường",
      icon: "location_city",
      path: PagePath.MARKET_INFORMATION,
    },
    {
      id: 3,
      title: "Site Planning Zone",
      icon: "map",
      path: PagePath.PLANNING_MAP,
    },
    {
      id: 4,
      title: "Đổi mật khẩu",
      icon: "lock",
      path: PagePath.RESET_PASSWORD,
    },
  ],
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SET_THEME: {
      return {
        ...state,
        theme: payload.theme,
      };
    }
    default:
      return state;
  }
};
